import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { CheckIvCatheterAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-check-iv-catheter-slot',
    templateUrl: './check-iv-catheter-slot.component.html',
    styleUrl: './check-iv-catheter-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckIvCatheterSlotComponent implements SheetSlotComponentBase {

	action!: CheckIvCatheterAction;
	value!: string | null;

	@Input('action') set updateAction(action: CheckIvCatheterAction | null) {
		this.action = action as CheckIvCatheterAction;
		this.value = this.action.day ? `Day ${this.action.day}` : '';
	}

	constructor() {
	}
}
